import { z } from 'zod'
import { oc } from '@orpc/contract'

export const getSlotsByOrganization = oc
  .route({ method: 'GET', path: '/v2/appointments/slots/by-organization' })
  .input(
    z.object({
      organizationId: z.string(),
      day: z.string().optional(),
    }),
  )
  .output(
    z.object({
      slots: z.array(z.object({}).passthrough()),
    }),
  )
